import React, { JSX } from 'react'
import { useLocation, useParams } from 'react-router'
import { ChatOverlayManager, QuickOverlayManagerView } from 'components/chatOverlays/ChatOverlayManager'
import { eventSectionPath } from 'lib/paths'

export const ChatsPage = (): JSX.Element => {
  const { eventId = '', chatId } = useParams<{ eventId: string, chatId: string }>()
  const { pathname } = useLocation()
  const basePath = eventSectionPath(eventId, 'chats')
  let view: QuickOverlayManagerView = 'list'
  if (pathname.endsWith('/new')) view = 'create'
  else if (chatId !== undefined) view = { edit: chatId }
  return (
    <ChatOverlayManager
      view={view}
      basePath={basePath}
      backLabel='Back to chat overlays'
    />
  )
}
